import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

const shortcutKey = "ecom-guinee-shortcut-created";

export default function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches
      || window.navigator.standalone;
    if (standalone || localStorage.getItem(shortcutKey)) return undefined;

    const promptHandler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShow(true);
    };
    const installedHandler = () => {
      localStorage.setItem(shortcutKey, "true");
      setShow(false);
    };

    setShow(true);
    window.addEventListener("beforeinstallprompt", promptHandler);
    window.addEventListener("appinstalled", installedHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", promptHandler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === "accepted") {
      localStorage.setItem(shortcutKey, "true");
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const confirmShortcut = () => {
    localStorage.setItem(shortcutKey, "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <aside className="install-prompt" data-testid="install-app-prompt">
      <div>
        <strong>Créer un raccourci</strong>
        <span>
          {deferredPrompt
            ? "Ajoutez Ecom Guinée à cet appareil pour un accès immédiat."
            : "Utilisez le menu de votre navigateur pour ajouter cette application à l’écran d’accueil."}
        </span>
      </div>
      {deferredPrompt ? (
        <button data-testid="install-app-button" onClick={install} type="button">
          <Download size={16} /> Ajouter
        </button>
      ) : (
        <button data-testid="confirm-shortcut-created-button" onClick={confirmShortcut} type="button">
          <Share size={16} /> Raccourci créé
        </button>
      )}
    </aside>
  );
}